import type { BulkIngestStatus } from "../../api/BulkAPI.types";

export type BulkStatusBucket = "active" | "pause" | "stop";

const BULK_STATUS_BUCKETS: readonly (readonly [
  BulkStatusBucket,
  readonly BulkIngestStatus[],
])[] = [
  ["active", ["complete"]],
  ["pause", ["created", "doing"]],
  ["stop", ["failed", "too_much_content"]],
];

const FALLBACK_BUCKET: BulkStatusBucket = "stop";

export function getBulkStatusBucket(
  status: BulkIngestStatus,
): BulkStatusBucket {
  const match = BULK_STATUS_BUCKETS.find(([, statusList]) =>
    statusList.includes(status),
  );

  return match ? match[0] : FALLBACK_BUCKET;
}

export function toApiStatusList(
  filterKey?: string | number,
): readonly BulkIngestStatus[] {
  if (filterKey === undefined) return [];

  const match = BULK_STATUS_BUCKETS.find(
    ([bucket]) => bucket === String(filterKey),
  );

  return match ? match[1] : [];
}
